import { HeaderList } from "../../../Components/Header/HeaderList";

const LoyaltyRedeemPage = () => {
  return (
    <div style={{ padding: 24 }}>
      <HeaderList
        title="Radeem Points"
        type="card"
      />
    </div>
  );
};

export default LoyaltyRedeemPage;
